import type { NotificationItem } from "@/shared/types/Notifications"; 
import api from "../api.client";

const BASE_URL = "/notifications"; 

const NotificationService = {
    async getUserNotifications(): Promise<NotificationItem[]> {
        return api.get<NotificationItem[]>(BASE_URL);
    }, 

    async markAsRead(id: string): Promise<void> {
        await api.patch(`${BASE_URL}/${id}/read`);
    },

    async delete(id: string): Promise<void> {
        await api.delete(`${BASE_URL}/${id}`);
    }
};

export default NotificationService;